import { render, staticRenderFns } from "./About.vue?vue&type=template&id=3c6d4ed2&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=3c6d4ed2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d4ed2",
  null
  
)

export default component.exports